import { render, staticRenderFns } from "./MainButton.vue?vue&type=template&id=6105da76&"
import script from "./MainButton.vue?vue&type=script&lang=js&"
export * from "./MainButton.vue?vue&type=script&lang=js&"
import style0 from "./MainButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports